<script>
    import {
        getMFAType,
        getDoctorStatus,
        getText,
        getFormatDate,
        isObjectEmpty,
        sendResetPwdEmail,
        getSVGClassNameFromClick,
    } from "../../../Utils/utilFunctions.svelte";

    import {
        SvelteTable,
        CardLayout,
        TableElementEditableStatus,
    } from "../../../Components/Common/index.svelte";

    import { user } from "../../../stores";

    import AccountAddEditUserModal from "./AccountAddEditUserModal.svelte";
    import { addIcon, editIcon } from "../../../Utils/utilConstants.svelte";

    export let accountId = Number(0),
        userDetails = [],
        reload = () => {};

    $: isEnableAddOrEditUser =
        $user.role == 100 || $user.role == 80 || $user.role == 20;

    $: if (isEnableAddOrEditUser) {
        btnOptions[0].isHidden = false;
        columns.push(actionColumn);
    } else btnOptions[0].isHidden = true;

    let isAddUserModalOpen = false,
        isAddingUser = false,
        newUserDetail = {};

    const actionColumn = {
        key: "buttons",
        title: "Actions",
        headerClass: "text-left pl-4 pr-6 text-[14px] rounded-tl-xl w-[2%]",
        class: "text-left pl-4 text-[14px] cursor-auto",
        renderValue: () => _renderActionIcons(),
    };

    const columns = [
        {
            key: "name",
            title: "Full name",
            value: (v) => getText(v.fullName),
            headerClass: "text-left pl-4 text-[14px] rounded-tl-xl",
            class: "text-left pl-4 text-[14px] cursor-auto",
        },
        {
            key: "email",
            title: "Email",
            value: (v) => getText(v.email),
            headerClass: "text-left pl-4 text-[14px]",
            class: "text-left pl-4 text-[14px] cursor-auto",
        },
        {
            key: "emailVerified",
            title: "Email Verified",
            renderValue: (v) => _renderTrueOrFalse(v.verifiedEmail),
            headerClass: "text-left pl-4 text-[14px]",
            class: "text-left pl-4 text-[14px] cursor-auto",
        },
        {
            key: "phone",
            title: "Phone",
            value: (v) => getText(v.phone),
            headerClass: "text-left pl-4 text-[14px]",
            class: "text-left pl-4 text-[14px] cursor-auto",
        },
        {
            key: "phoneVerified",
            title: "Mobile Verified",
            renderValue: (v) => _renderTrueOrFalse(v.verifiedPhone),
            headerClass: "text-left pl-4 text-[14px]",
            class: "text-left pl-4 text-[14px] cursor-auto",
        },
        {
            key: "role",
            title: "Role",
            renderValue: (v) => _renderListComponent(v.roles),
            headerClass: "text-left pl-4 text-[14px]",
            class: "text-left pl-4 text-[14px] cursor-auto",
        },
        {
            key: "mfa",
            title: "MFA",
            value: (v) => getMFAType(v.mfa),
            headerClass: "text-left pl-4 text-[14px]",
            class: "text-left pl-4 text-[14px] cursor-auto",
        },
        {
            key: "status",
            title: "Status",
            value: (v) => getDoctorStatus(v.status),
            headerClass: "text-left pl-4 text-[14px]",
            class: "text-left pl-4 text-[14px]",
            renderComponent: {
                component: TableElementEditableStatus,
                props: {
                    type: "user",
                    onFinish: () => reload(),
                },
            },
        },
        {
            key: "lastLogIn",
            title: "Last LogIn Date",
            renderValue: (v) => getFormatDate(v.loggedInDate),
            headerClass: "text-left pl-4 text-[14px]",
            class: "text-left pl-4 text-[14px] cursor-auto",
        },
    ];

    const btnOptions = [
        {
            iconName: "addIcon",
            hasTooltip: false,
            iFont: addIcon,
            iconFunction: () => _openAddUserModal(),
            btnText: "Add",
        },
    ];
    const handleClickCell = (
        e,
        rowData,
        key,
    ) => {
        const className = getSVGClassNameFromClick(e)
        if (key == "buttons") {
            if (className?.includes("editIcon"))
                _openAddUserModal(rowData);
            if (className?.includes("resetPasswordIcon") && rowData.email)
                sendResetPwdEmail(rowData.email);
        }
    };

    const handleClickCol = ({ target: { className } }, colData, key) => {};

    // HELPER FUNCTIONS
    const _renderTrueOrFalse = (isTrue) => {
        if (isTrue)
            return `<div class="flex flex-1 items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" class="stroke-current flex-shrink-0 h-6 w-6 text-secondary" fill="none" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                    </div>`;
        else
            return `<div class="flex flex-1 items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" class="stroke-current flex-shrink-0 h-6 w-6 text-secondary" fill="none" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                    </div>`;
    };

    const _renderListComponent = (arr) => {
        const res = [];
        let component;
        if (arr && arr.length) {
            arr.forEach((target) => {
                component = `<div class="cursor-auto">${target.name}</div>`;
                res.push(component);
            });
        }
        return res.toString().replaceAll(",", "<br>");
    };

    const _renderActionIcons = () => {
        return `<div class="flex flex-1 items-center justify-start gap-x-2">
                    <div class="resetPasswordIcon tooltip tooltip-secondary tooltip-left flex items-center justify-center cursor-pointer w-[30px] h-[30px] hover:rounded-full hover:bg-secondary hover:text-white" data-tip="Send Reset Password Email">
                        <svg fill="#6F726C" xmlns="http://www.w3.org/2000/svg" class="resetPasswordIcon hover:text-white" width="16px" height="16px" viewBox="0 0 52 52" enable-background="new 0 0 52 52" xml:space="preserve" stroke="#6F726C"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M42,23H10c-2.2,0-4,1.8-4,4v19c0,2.2,1.8,4,4,4h32c2.2,0,4-1.8,4-4V27C46,24.8,44.2,23,42,23z M31,44.5 c-1.5,1-3.2,1.5-5,1.5c-0.6,0-1.2-0.1-1.8-0.2c-2.4-0.5-4.4-1.8-5.7-3.8l3.3-2.2c0.7,1.1,1.9,1.9,3.2,2.1c1.3,0.3,2.6,0,3.8-0.8 c2.3-1.5,2.9-4.7,1.4-6.9c-0.7-1.1-1.9-1.9-3.2-2.1c-1.3-0.3-2.6,0-3.8,0.8c-0.3,0.2-0.5,0.4-0.7,0.6L26,37h-9v-9l2.6,2.6 c0.4-0.4,0.9-0.8,1.3-1.1c2-1.3,4.4-1.8,6.8-1.4c2.4,0.5,4.4,1.8,5.7,3.8C36.2,36.1,35.1,41.7,31,44.5z"></path> <path d="M10,18.1v0.4C10,18.4,10,18.3,10,18.1C10,18.1,10,18.1,10,18.1z"></path> <path d="M11,19h4c0.6,0,1-0.3,1-0.9V18c0-5.7,4.9-10.4,10.7-10C32,8.4,36,13,36,18.4v-0.3c0,0.6,0.4,0.9,1,0.9h4 c0.6,0,1-0.3,1-0.9V18c0-9.1-7.6-16.4-16.8-16c-8.5,0.4-15,7.6-15.2,16.1C10.1,18.6,10.5,19,11,19z"></path> </g> </g></svg>
                    </div>
                    <div class="editIcon tooltip tooltip-secondary tooltip-left flex items-center justify-center cursor-pointer w-[30px] h-[30px] hover:rounded-full hover:bg-secondary hover:text-white" data-tip="Edit User Details">
                        <i class="editIcon ${editIcon}"></i>
                    </div>
            </div>`;
    };

    const _openAddUserModal = (userDetails = {}) => {
        isAddUserModalOpen = true;
        if (!isObjectEmpty(userDetails)) newUserDetail = { ...userDetails };
    };

    const _closeAddUserModal = () => {
        isAddUserModalOpen = false;
        newUserDetail = {};
    };
</script>

<CardLayout title="User Details" {btnOptions}>
    {#if userDetails.length}
        <div class="flex flex-1 overflow-auto">
            <SvelteTable
                {columns}
                rows={userDetails}
                clickCellFunc={({ detail: { event, row, key } }) => {
                    handleClickCell(event, row, key);
                }}
                clickColFunc={({ detail: { event, row, key } }) => {
                    handleClickCol(event, row, key);
                }}
            />
        </div>
    {:else}
        <div class="grid flex-1 h-full card bg-white rounded-box">
            <div class="flex flex-col flex-1 px-2 py-4 w-full lg:flex-row">
                <p>No users currently under this doctor</p>
            </div>
        </div>
    {/if}
</CardLayout>

{#if isAddUserModalOpen}
    <AccountAddEditUserModal
        {accountId}
        userDetails={newUserDetail}
        isModalOpen={isAddUserModalOpen}
        closeModal={_closeAddUserModal}
        afterModifyAction={reload}
    />
{/if}
